import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// import wagmiConfig2 from './utils/walletConnect';
import { wagmiConfig } from './utils/wagmiConfig';
import { useAccount } from './utils/useAccount';
import { dologin } from './utils/useWeb3Modal';
import Clipboard from "v-clipboard";
import {
	Overlay,Uploader,Button,DropdownMenu, DropdownItem,
	Tab, Tabs, Empty,
	// showConfirmDialog,
	Popover,
	GridItem,
	Grid,
	List,
	Notify,
	RollingText,
	ShareSheet,
	Badge,
	closeToast,
	Toast,
	Dialog,
	showLoadingToast,
	DatePicker,
	showToast,
	NoticeBar,
	Swipe,
	SwipeItem,
	Icon,
	Progress,
	Field,
	Collapse, CollapseItem,
	Cell,Rate,Circle,
	RadioGroup,
	Radio,
	PasswordInput,
	NumberKeyboard,
	Popup,
	Picker,
	CellGroup,
	ActionSheet,
	CountDown, Checkbox
} from "vant";
import 'vant/lib/index.css';

import vueTouch from "vue-plugin-touch";
import touch from 'vue-directive-touch';
import { createI18n } from 'vue-i18n';
import '@/assets/styles/reset.scss';
import 'lib-flexible';
import { formatMoney } from './utils/money';

const baseMessages = {
	'zh_cn': require('./assets/languages/zh_CN.json'),
	'zh_hk': require('./assets/languages/zh_HK.json'),
	'en_us': require('./assets/languages/en_US.json'),
	'th_th': require('./assets/languages/th_TH.json'),
	'ja_jp': require('./assets/languages/ja_JP.json'),
	'ko_kr': require('./assets/languages/ko_KR.json'),
	'ms_my': require('./assets/languages/ms_MY.json'),
	'pt_br': require('./assets/languages/pt_BR.json'),
	'ir_fa': require('./assets/languages/ir_fa.json'),
	'ar_ar': require('./assets/languages/ar_ar.json'),
	'db_de': require('./assets/languages/db_de.json'),
	'id_ind': require('./assets/languages/id_ind.json'),
	'vi_vn': require('./assets/languages/vi_VN.json')
};

const i18n = createI18n({
  locale: localStorage.getItem("lang") || "en_us",
  messages: baseMessages
});

// import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi/vue'
// import { mainnet, polygon } from 'viem/chains'


// import { 
// 	getAccount,
// 	getChainId,
// 	reconnect,
// 	watchClient,
// 	watchAccount,
// 	watchChainId } from '@wagmi/core'
// // 1. Define constants
// const projectId = 'a5825827a80f6c5cc3059bb2b21c5417'

// // 2. Create wagmiConfig
// const metadata = {
//   name: 'Web3Modal',
//   description: 'Web3Modal Example',
//   url: 'https://web3modal.com', // origin must match your domain & subdomain
//   icons: ['https://avatars.githubusercontent.com/u/37784886']
// }

// const chains = [polygon]
// const config = defaultWagmiConfig({
//   chains,
//   projectId,
//   metadata,
//   enableCoinbase: false,
//   enableInjected: false,
//   auth: {
// 	  email: false, // default to true
// 	  // socials: ['google', 'x', 'github', 'discord', 'apple', 'facebook', 'farcaster'],
// 	  showWallets: true, 
// 	  walletFeatures: true 
// 	}
//   // ...wagmiOptions // Optional - Override createConfig parameters
// })

// reconnect(config)
// // 3. Create modal
// createWeb3Modal({
// 	wagmiConfig: config,
// 	projectId,
// 	themeMode: 'dark',
// 	enableOnramp: true,
// 	enableSwaps: true,
// 	enableAnalytics: true  
// })

// const unwatch = watchAccount(config, {
//   onChange(data) {
//     console.log('Account changed!', data)
//   },
// })
// unwatch()
// const unwatch2 = watchClient(config, {
//   onChange(client) {
//     console.log('Client changed!', client)
//   },
// })
// unwatch2()
// const chainId = readable(
//     getChainId(wagmiConfig),
//     (set) =>
//         watchChainId(wagmiConfig, { onChange: set }),
// );

// const account = readable(
//     getAccount(wagmiConfig),
//     (set) =>
//         watchAccount(wagmiConfig, { onChange: set }),
// );

// const provider = readable(
//     undefined,
//     (set) =>
//     watchAccount(wagmiConfig, {
//         onChange: async (account) => {
//             if (!account.connector) return set(undefined);
//             set(await (account.connector ? account.connector.getProvider() : undefined));
//         },
//     }),
// );


const app = createApp(App);
// app.config.errorHandler = (err, vm, info) => {
//   console.error(`Error: ${err.toString()}\nInfo: ${info}`);
//   showNotify({ type: 'danger', message: err.message || 'Unknown error' });
// };

// app.config.warnHandler = (msg, vm, trace) => {
//   console.warn(`Warn: ${msg}\nTrace: ${trace}`);
// }
app.provide('wagmiConfig', wagmiConfig);
app.provide('useAccount', useAccount);
app.provide('dologin', dologin);
app.use(router)
	.use(closeToast)
	.use(Popover)
	.use(GridItem)
	.use(Grid)
	.use(List)
	.use(Toast)
	.use(Badge)
	.use(Circle)
	.use(Rate)
	.use(Overlay)
	.use(Uploader)
	.use(RadioGroup)
	.use(Radio)
	.use(Button)
	.use(DropdownMenu)
	.use(DropdownItem)
	.use(Tab)
	.use(Tabs)
	.use(Empty)
	.use(CountDown)
	.use(ShareSheet)
	.use(Checkbox)
	.use(store)
	.use(i18n)
	.use(Clipboard)
	.use(RollingText)
	.use(Notify)
	.use(showToast)
	.use(Dialog)
	// .use(showDialog)
	.use(vueTouch)
	.use(touch)
	.use(DatePicker)
	.use(Icon)
	.use(Progress)
	.use(Field)
	.use(showLoadingToast)
	// .use(showSuccessToast)
	// .use(showFailToast)
	.use(NoticeBar)
	.use(Swipe)
	.use(PasswordInput)
	.use(NumberKeyboard)
	.use(wagmiConfig)
	.use(Popup)
	.use(Picker)
	.use(ActionSheet)
	// .use(showConfirmDialog)
	.use(Collapse)
	.use(CollapseItem)
	.use(Cell).use(CellGroup)
	.use(SwipeItem);


app.config.globalProperties.utils_moneyMark = function (coin=0) {
	if(coin==1){
		return ' AED';//+this.$t('vip.vippoint');
	}else if(coin==2){
		return ' Points';//+this.$t('vip.vippoint');
	}else{
		return ' AED';
	}
};
app.config.globalProperties.utils_formatt = function (t) {
	if (!t) return '';
	const date = new Date(t*1000);
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	const seconds = String(date.getSeconds()).padStart(2, '0');
	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
app.config.globalProperties.utils_moneyFormat = function (value, precision) {
	return formatMoney(value, precision);
};
app.config.globalProperties.showcover = false;

app.mount('#app');



